// extracted by mini-css-extract-plugin
export default {"notification":"NotificationCounter_notification__AvhCT"};